export const productionDepartments = {
	STYLE_ATTRIBUTES: { name: "Style Attributes", key: "STYLE_ATTRIBUTES" },
	FABRIC_TRIMS: { name: "Fabric & Trims", key: "FABRIC_TRIMS" },
};

export const selectedStyleTabUrlKey = "tab";

export const isValidSelectedStyleTab = (tab) =>
	Object.values(productionDepartments).some((department) => department.key === tab);
